import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions } from '../../../../../adapters/types'
import { DischargeFormData } from '../../../../types/formData'
import { DischargeFormField } from '../../../../types/formField'
import { DischargeAssessmentQuestionnaireItem } from '../../../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../../../helpers'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { FlatAnswerMutation } from '../../../../../adapters/types'

/**
 * Sensory subsection adapter
 * Handles sensory status for all five senses plus system summary (6 fields)
 */
export class SensoryAdapter extends BaseSubsectionAdapter<DischargeFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<DischargeFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // All sensory status fields
    const statusEyes = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EYES
    )?.at(0)

    const statusEars = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EARS
    )?.at(0)

    const statusNose = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_NOSE
    )?.at(0)

    const statusTouch = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TOUCH
    )?.at(0)

    const statusTaste = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TASTE
    )?.at(0)

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [DischargeFormField.SENSORY_STATUS_EYES]: statusEyes,
      [DischargeFormField.SENSORY_STATUS_EARS]: statusEars,
      [DischargeFormField.SENSORY_STATUS_NOSE]: statusNose,
      [DischargeFormField.SENSORY_STATUS_TOUCH]: statusTouch,
      [DischargeFormField.SENSORY_STATUS_TASTE]: statusTaste,
      [DischargeFormField.SENSORY_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(DischargeFormField.SENSORY_STATUS_EYES)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EYES,
        value: this.getFormDataField(DischargeFormField.SENSORY_STATUS_EYES)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.SENSORY_STATUS_EARS)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EARS,
        value: this.getFormDataField(DischargeFormField.SENSORY_STATUS_EARS)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.SENSORY_STATUS_NOSE)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_NOSE,
        value: this.getFormDataField(DischargeFormField.SENSORY_STATUS_NOSE)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.SENSORY_STATUS_TOUCH)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TOUCH,
        value: this.getFormDataField(DischargeFormField.SENSORY_STATUS_TOUCH)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.SENSORY_STATUS_TASTE)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TASTE,
        value: this.getFormDataField(DischargeFormField.SENSORY_STATUS_TASTE)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.SENSORY_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SYSTEM_SUMMARY,
        value: this.getFormDataField(DischargeFormField.SENSORY_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
